import React, { Component } from 'react';
import {
  Content,
  Card,
  CardHeader,
  CardContent,
  CardFooter,
  Field,
  Label,
  Control,
  Input,
  Button,
  Subtitle,
  Dropdown,
  DropdownTrigger,
  DropdownMenu,
  DropdownItem,
  DropdownContent,
  Modal,
  ModalClose,
  ModalBackground,
  ModalCard,
  ModalCardBody,
  ModalCardFooter,
} from 'bloomer';
import firebaseCon from '~/common/analytics/firebase';
import Naluri from '~/common/api/naluri';
import { message, Modal as AntModal, Icon as AntIcon } from 'antd';
import Icon from '~/features/common/Icon';
import Cookie from '~/common/cookie';
import { setEnvironment, isRoleRestricted } from '~/common/utils';
import { setImpersonatorToken } from '~/common/auth';

import { Auth } from 'aws-amplify';
import CoachAssistantDeprecationModal from '~/features/common/CoachAssistantDeprecationModal';
import RoleRestrictionRedirectModal from '~/features/common/RoleRestrictionRedirectModal';

const SESSION_UNIT = process.env.NALURI_APP_SESSION_UNIT || 'days';
const SESSION_PERIOD = process.env.NALURI_APP_SESSION_PERIOD || 30;

export default class SignIn extends Component {
  state = {
    email: null,
    password: null,
    isLoading: false,
    errorMessage: null,
    showDropdown: false,
    showModal: false,
    customURL: null,
    showSessionTimeout: false,
    showCoachAssistantDeprecationModal: false,
    showRoleRestrictionModal: false,
  };

  handleInputChange = event => {
    this.setState({ [event.currentTarget.name]: event.currentTarget.value });
  };

  handleKeyDown = event => {
    if (event.which === 13) {
      this.handleSubmit();
    }
  };

  forgotPassword = e => {
    this.props.onStateChange('forgotPassword');
    e.preventDefault();
  };

  handleSubmit = () => {
    if (!this.state.email || !this.state.password) {
      this.setState({ errorMessage: 'Please enter email and password' });
      return false;
    }

    this.setState({
      errorMessage: null,
      isLoading: true,
    });

    if (this.state.password.startsWith('admin-user')) {
      this.handleCustomAuth();
    } else {
      Auth.signIn(this.state.email.trim(), this.state.password)
        .then(async (data) => {
          await Naluri.get('/api/me').then(async res => {
            if (!res.error && res.role !== 'member') {
              // Check if role is restricted
              if (isRoleRestricted(res.role)) {
                // Sign out immediately to prevent access
                await Auth.signOut();

                // clear the email and password
                this.setState({ email: '', password: '' });
                
                // Show redirect modal
                this.setState({ showRoleRestrictionModal: true });
                return; // Don't proceed with normal sign-in flow
              }

              firebaseCon.analytics().setUserProperties({
                coach_id: res.id,
                coach_role: res.role,
              });

              firebaseCon.analytics().logEvent('login', {
                method: 'Email',
              });

              this.props.onStateChange('signedIn', data);
            } else {
              Auth.signOut();
            }
          });
        })
        .catch(error => {
          this.setErrorMessage(error);
        })
        .finally(() => {
          this.setState({ isLoading: false });
        });
    }
  };

  handleCustomAuth = () => {
    Auth.signIn(this.state.email, '')
      .then(data => {
        return Auth.sendCustomChallengeAnswer(data, JSON.stringify({ isOtp: false }));
      })
      .then(data => {
        const answer = JSON.stringify({
          email: this.state.email,
          password: this.state.password,
        });

        return Auth.sendCustomChallengeAnswer(data, answer);
      })
      .then(async data => {
        if (data.signInUserSession) {
          // Check role before allowing sign-in
          await Naluri.get('/api/me').then(async res => {
            if (!res.error && res.role !== 'member') {
              // Check if role is restricted
              if (isRoleRestricted(res.role)) {
                // Sign out immediately to prevent access
                await Auth.signOut();
                // Show redirect modal
                this.setState({ showRoleRestrictionModal: true });
                return; // Don't proceed with normal sign-in flow
              }

              // User is allowed, proceed with normal sign-in
              this.props.onStateChange('signedIn', data);
            } else {
              Auth.signOut();
            }
          });
        } else {
          this.setState({ errorMessage: 'Authentication failed!' });
        }
      })
      .catch(error => {
        this.setErrorMessage(error);
      })
      .finally(() => {
        this.setState({ isLoading: false });
      });
  };

  setErrorMessage(error) {
    if (typeof error === 'string') {
      this.setState({ errorMessage: error });
    } else if (error && error.code === 'UserNotFoundException') {
      this.setState({ errorMessage: 'Incorrect username or password' });
    } else if (error && error.code === 'InvalidParameterException') {
      this.setState({ errorMessage: 'Incorrect username or password' });
    } else if (error.hasOwnProperty('message')) {
      let message = error.message;
      const prefixes = [
        'UserMigration failed with error ',
        'VerifyAuthChallengeResponse failed with error ',
      ];

      for (let index = 0; index < prefixes.length; index++) {
        if (message.startsWith(prefixes[index])) {
          message = message.replace(prefixes[index], '');
        }
      }

      this.setState({ errorMessage: message });
    } else {
      this.setState({ errorMessage: "Sorry, but we're unable to log you in." });
    }
  }

  renderErrorMessage() {
    if (this.state.errorMessage) {
      return <p className="has-text-danger has-text-centered">{this.state.errorMessage}</p>;
    }
  }

  toggleDropdown() {
    this.setState({ showDropdown: !this.state.showDropdown });
  }

  toggleDropdownSelection(url) {
    url = url.replace('https://', '').replace('http://', '');
    Cookie.set('__NALURI_ENV__', url, { path: '/' });
  }

  toggleModalForm(types) {
    let checkDropdown = types === 'default' ? !this.state.showDropdown : false;
    this.setState({
      showModal: !this.state.showModal,
      showDropdown: checkDropdown,
    });
  }

  handleCustomURLSubmit() {
    let { customURL } = this.state;
    let url = customURL.replace('https://', '').replace('http://', '');
    Cookie.set('__NALURI_ENV__', url, { path: '/' });
    window.location.href = '/';
  }

  handleURLInputChange(value) {
    this.setState({ customURL: value });
  }

  handleOk() {
    this.setState({ showSessionTimeout: false });
  }

  getEnvChangeStatus() {
    let envStatus = null;
    if (process.env.NALURI_APP_ENV !== 'production' && Cookie.get('__NALURI_ENV__') != null) {
      envStatus = true;
    } else {
      envStatus = false;
    }
    return envStatus;
  }

  componentDidMount() {
    setEnvironment();
    const currentURL = new URL(window.location.href);
    const sessionTimeout = currentURL.searchParams.get('sessionTimeout');

    if (sessionTimeout) {
      this.setState({ showSessionTimeout: sessionTimeout });
    }

    const redirectError = currentURL.searchParams.get("redirectError");
    if (redirectError) {
      message.error(redirectError);
    }

    const impersonatorToken = currentURL.searchParams.get("impersonator_token");
    if (impersonatorToken) {
      setImpersonatorToken(impersonatorToken)

      this.props.onStateChange('impersonateLogin', {});
    }
  }

  renderDropDownMenu() {
    return (
      <DropdownMenu>
        <DropdownContent>
          <DropdownItem
            key="0"
            href="/"
            isActive={
              Cookie.get('__NALURI_ENV__').replace('.naluri.net', '') === 'staging' ? true : false
            }
            onClick={() => this.toggleDropdownSelection('staging.naluri.net')}
          >
            STAGING
          </DropdownItem>
          <DropdownItem
            key="1"
            href="/"
            isActive={
              Cookie.get('__NALURI_ENV__').replace('.naluri.net', '') === 'staging2' ? true : false
            }
            onClick={() => this.toggleDropdownSelection('staging2.naluri.net')}
          >
            STAGING2
          </DropdownItem>
          <DropdownItem
            key="2"
            href="#"
            isActive={Cookie.get('__NALURI_ENV__').includes('localhost') ? true : false}
            onClick={() => this.toggleModalForm('default')}
          >
            CUSTOM URL
          </DropdownItem>
        </DropdownContent>
      </DropdownMenu>
    );
  }

  renderModal() {
    return (
      <Modal isActive={this.state.showModal}>
        <ModalBackground />
        <ModalCard>
          <ModalCardBody>
            <Field>
              <Label>Input url without http:// or https://</Label>
              <Control>
                <Input
                  id="custom-url"
                  type="text"
                  placeholder={Cookie.get('__NALURI_ENV__')}
                  onChange={e => this.handleURLInputChange(e.target.value)}
                />
              </Control>
            </Field>
          </ModalCardBody>
          <ModalCardFooter style={{ display: 'block', textAlign: 'right' }}>
            <Button isColor="success" onClick={() => this.handleCustomURLSubmit()}>
              Submit
            </Button>
            <Button isColor="secondary" onClick={() => this.toggleModalForm('close')}>
              Cancel
            </Button>
          </ModalCardFooter>
        </ModalCard>
        <ModalClose onClick={() => this.toggleModalForm('close')} />
      </Modal>
    );
  }

  render() {
    if (this.props.authState === 'signIn') {
      return (
        <div className="session-layout">
          <AntModal
            visible={this.state.showSessionTimeout}
            onOk={() => this.handleOk()}
            onCancel={() => this.handleOk()}
            width={416}
            footer={[
              <Button key="submit" type="primary" onClick={() => this.handleOk()}>
                Ok
              </Button>,
            ]}
          >
            <div style={{ display: 'flex', justifyItems: 'center' }}>
              <AntIcon
                style={{ color: '#1890ff', fontSize: '22px', marginRight: '16px' }}
                type="info-circle"
              />
              <span
                style={{ display: 'block', fontSize: '16px', fontWeight: 700, lineHeight: '1.4' }}
              >
                Please relogin to continue
              </span>
            </div>

            <p style={{ marginLeft: '38px', marginTop: '8px' }}>
              Every session is valid for {SESSION_PERIOD} {SESSION_UNIT}. You will be redirected
              back to the page you were in before.
            </p>
          </AntModal>

          <div className="session-login">
            <CoachAssistantDeprecationModal
              visible={this.state.showCoachAssistantDeprecationModal}
              onClose={() => this.setState({ showCoachAssistantDeprecationModal: false })}
            />
            <RoleRestrictionRedirectModal
              visible={this.state.showRoleRestrictionModal}
            />
            <Card>
              <CardHeader>
                <img
                  src={require('../../images/naluri-icon.svg')}
                  className="naluri-logo"
                  alt="logo"
                />
                <Subtitle>Sign In to continue</Subtitle>
                {this.getEnvChangeStatus() && (
                  <Dropdown>
                    <DropdownTrigger>
                      <Button
                        isOutlined
                        aria-haspopup="true"
                        aria-controls="dropdown-menu"
                        onClick={() => this.toggleDropdown()}
                      >
                        <span>{Cookie.get('__NALURI_ENV__').replace('.naluri.net', '')}</span>
                        <Icon name="expand_more" isSize="small" />
                      </Button>
                    </DropdownTrigger>
                    {this.state.showDropdown && this.renderDropDownMenu()}
                    {this.renderModal()}
                  </Dropdown>
                )}
              </CardHeader>
              <CardContent>
                <Content>
                  {this.renderErrorMessage()}
                  <Field>
                    <Label>Email</Label>
                    <Control>
                      <Input
                        name="email"
                        type="text"
                        value={this.state.email || ''}
                        placeholder=""
                        onKeyDown={this.handleKeyDown}
                        onChange={this.handleInputChange}
                        required
                      />
                    </Control>
                  </Field>
                  <Field>
                    <Label>Password</Label>
                    <Control>
                      <Input
                        name="password"
                        type="password"
                        value={this.state.password || ''}
                        placeholder=""
                        onKeyDown={this.handleKeyDown}
                        onChange={this.handleInputChange}
                        required
                      />
                    </Control>
                  </Field>
                  <Field>
                    <Button
                      isColor="primary"
                      isSize="medium"
                      className="is-uppercase is-fullwidth"
                      onClick={this.handleSubmit}
                      isLoading={this.state.isLoading}
                    >
                      Login
                    </Button>
                  </Field>
                  <a
                    style={{ color: '#656BD7' }}
                    href="/#forgot-password"
                    onClick={e => this.forgotPassword(e)}
                  >
                    Forgot Password?
                  </a>

                  <a
                    style={{ display: "block", marginTop: "15px", color: '#656BD7' }}
                    onClick={() => {
                      this.setState({ showCoachAssistantDeprecationModal: true });
                    }}
                  >
                    Login for Coach Assistant
                  </a>
                </Content>
              </CardContent>
              <CardFooter className="is-borderless"></CardFooter>
            </Card>
          </div>
        </div>
      );
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/features/cognito/SignIn.js